<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Client" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">View Transport Rate</h4>
                    </div>
                    <div class="flex items-center" >
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editForm" v-show="!editMode">Edit</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" v-show="editMode">Save</vs-button>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input disabled class="w-full" label="ID *" v-model="data.id" />
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Client ID *</label>
                                <v-select :options="clientOption" v-model="data.client_id" label="client_code" @search="searchClient" :disabled="!editMode" :clearable="false"></v-select>
                            </div>
                        </div>
                        
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Origin ID *</label>
                                <v-select :options="areaOptions" v-model="data.origin_id" label="village"  @search="searchArea" :disabled="!editMode" :clearable="false"></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Destination ID *</label>
                                <v-select :options="areaOptions" v-model="data.destination_id" label="village"  @search="searchArea" :disabled="!editMode" :clearable="false"></v-select>
                            </div>
                        </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full">

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Transporter ID *</label>
                                <v-select :options="transporterOption" v-model="data.transporter_id" label="name"  @search="searchTransporter" :disabled="!editMode"  :clearable="false"></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Vehicle Type ID *</label>
                                <v-select :options="vehicleTypeOption" v-model="data.vehicle_type_id" label="vehicle_type"  @search="searchVehicleType" :disabled="!editMode"  :clearable="false"></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Contract Type ID *</label>
                                <v-select :options="contractTypeOption" v-model="data.contract_type_id" label="contract_type"  @search="searchContractType" :disabled="!editMode"  :clearable="false"></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Service Type ID</label>
                                <v-select :options="serviceTypeOption" v-model="data.service_type_id" label="service_type" :disabled="!editMode"  @search="searchVehicleType"></v-select>
                            </div>
                        </div>

                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <!-- <vs-input  class="w-full" label="Status" v-model="data.status.name" :disabled="true"/> -->
                                <label for="" class="vs-input--label" >Status </label>
                                <vs-switch class="mt-2" v-model="data.is_active" :disabled="!editMode">
                                    <span slot="on">Active</span>
                                    <span slot="off">Deactive</span>
                                </vs-switch>
                            </div>
                        </div>

                    </div>
                </div>
                <vs-tabs class="mt-6">
                    <vs-tab label="Trip Rate">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/2 w-full">
                                
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Currency
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="currencyOption" v-model="data.currency_id" label="currency_code" :disabled="!editMode" :clearable="false"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Fixed Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.fixed_rate" :disabled="!editMode" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Quota Trip
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.quota_trip" :disabled="!editMode"/>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Period
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="periodRateOption" v-model="data.period_id" label="name"  :disabled="!editMode"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Excess Trip Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.excess_trip_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Trip Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.trip_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Variables">

                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/3 w-full">
 
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Volume Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.volume_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                                 <div class="vx-row mb-8">
                                    <div class="vx-col w-1/3">
                                        Min Volume
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group >
                                          <template slot="append">
                                            <div class="append-text bg-primary">
                                              <span>M3</span>
                                            </div>
                                          </template>

                                          <vs-input  class="w-full" v-model="data.min_volume"  :disabled="!editMode"/>
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Weight Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.weight_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Min Weight
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group>
                                          <template slot="append">
                                            <div class="append-text bg-primary">
                                              <span>KG</span>
                                            </div>
                                          </template>

                                          <vs-input  class="w-full" v-model="data.min_weight" :disabled="!editMode" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Max Weight
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group >
                                          <template slot="append">
                                            <div class="append-text bg-primary">
                                              <span>KG</span>
                                            </div>
                                          </template>

                                          <vs-input  class="w-full" v-model="data.max_weight" :disabled="!editMode" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-8">
                                    <div class="vx-col w-1/3">
                                        Excess Weight Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.excess_weight_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                                <div class="vx-row mb-8">
                                    <div class="vx-col w-1/3">
                                        Quantity Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.quantity_rate" :disabled="!editMode"/>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/3 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Multi Drop Rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.multi_drop_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Applied After
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vx-input-group>
                                          <template slot="append">
                                            <div class="append-text bg-primary">
                                              <span>Drops</span>
                                            </div>
                                          </template>

                                          <vs-input  class="w-full" v-model="data.applied_after" :disabled="!editMode" />
                                        </vx-input-group>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Load / Unload rate
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.load_unload_rate" :disabled="!editMode"/>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </vs-tab>
                    <vs-tab label="Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.notes" label="Notes" height="200" :disabled="!editMode"/>
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>

            </vs-card>
        </div>
    </div>
</template>


<script>
	import vSelect from 'vue-select'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';


	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                isLoading: false,
                editMode:false,
                data: {
                    id: '',
                    client_id:null,
                    origin_id:null,
                    destination_id:null,
                    status: '',
                    transporter_id:null,
                    vehicle_type_id:null,
                    contract_type_id:null,
                    // service_type_id:null,

                    // trip rate
                    currency_id:null,
                    fixed_rate:0,
                    quota_trip:0,
                    period_id:null,
                    excess_trip_rate:0,
                    trip_rate:0,

                    //variable
                    volume_rate:0,
                    min_volume:0,
                    weight_rate:0,
                    min_weight:0,
                    max_weight:0,
                    excess_weight_rate:0,
                    quantity_rate:0,
                    multi_drop_rate:0,
                    applied_after:0,
                    load_unload_rate:0,

                    // notes
                    notes:'',
                    is_active:true,


                },
                clientTypeOptions: [],
                areaOptions:[],
                clientOption: [],
                transporterOption: [],
                vehicleTypeOption: [],
                contractTypeOption:[],
                serviceTypeOption:[],
                currencyOption:[],
                periodRateOption:[],
                maxRetry: 10,
            }
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        village: search
                    }
                    this.$http.post('master/get_areas', data)
                    .then(res => {
                        this.areaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchClient(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/clients/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchClient(search, loading)
                    })
                }
            },
            searchTransporter(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/transporters/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchTransporter(search, loading)
                    })
                }
            },
            searchVehicleType(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/vehicletypes/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchVehicleType(search, loading)
                    })
                }
            },
            searchContractType(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/vehicletypes/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchContractType(search, loading)
                    })
                }
            },
            searchServiceType(search, loading) {
                // if(search.length > 2){
                //     loading(true)
                //     const data = {
                //         name: search
                //     }
                //     this.$http.post('master/serve/filter/search', data)
                //     .then(res => {
                //         this.clientOption = res.data
                //         loading(false)
                //     })
                //     .catch(() => {
                //         this.searchServiceType(search, loading)
                //     })
                // }
            },
            fetchData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                this.$http.get('master/transporterrates/' + this.$route.params.id)
                .then(rate => {
                    this.clientOption = [rate.data.client]
                    this.transporterOption = [rate.data.transporter]
                    this.areaOptions = [rate.data.origin, rate.data.destination]
                    this.vehicleTypeOption = [rate.data.vehicle_type]
                    this.contractTypeOption = [rate.data.contract_type]
                    // this.serviceTypeOption = [rate.data.service_type]
                    this.currencyOption = [rate.data.currency]
                    this.periodRateOption = [rate.data.period]
                    
                    this.data = rate.data

                    this.data.client_id = rate.data.client
                    this.data.transporter_id = rate.data.transporter
                    this.data.origin_id = rate.data.origin
                    this.data.destination_id = rate.data.destination
                    this.data.vehicle_type_id = rate.data.vehicle_type
                    this.data.contract_type_id = rate.data.contract_type
                    this.data.service_type_id = rate.data.service_type
                    this.data.currency_id = rate.data.currency
                    this.data.period_id = rate.data.period
                    this.data.is_active = rate.data.is_active == 1 ? true : false

                    console.log(this.data.client_id)

                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                })
                .catch(() => {
                    if(this.maxRetry == 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchData()
                                this.maxRetry = 10
                            },
                            // cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        });
                        return;
                    }
                    this.fetchData()
                })
            },
            submitForm() {
                this.isLoading = true
                  let data = {...this.data, 
                    client_id: this.data.client_id != null ? this.data.client_id.id : null,
                    transporter_id: this.data.transporter_id != null ? this.data.transporter_id.id : null, 
                    origin_id: this.data.origin_id != null ?  this.data.origin_id.id : null, 
                    destination_id: this.data.destination_id != null ? this.data.destination_id.id : null, 
                    vehicle_type_id: this.data.vehicle_type_id != null ? this.data.vehicle_type_id.id : null, 
                    contract_type_id: this.data.contract_type_id != null ? this.data.contract_type_id.id : null, 
                    service_type_id: this.data.service_type_id != null ? this.data.service_type_id.id  : null, 
                    currency_id: this.data.currency_id != null ? this.data.currency_id.id : null, 
                    period_id: this.data.period_id != null ? this.data.period_id.id : null, 
                    is_active:this.data.is_active == true ? 1 : 0,
                } 
                this.$http.put('master/transporterrates/' + this.$route.params.id + '/update', data)
                .then(res => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Saved Successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Transporter Rate updated successfully'
                    })
                    this.$router.push({ name: "master-transporter-rate" });
                })
                .catch(error => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Error saving'
                    })
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => { this.$router.go(-1) },
                    })
                }
                else{
                    this.$router.go(-1)
                }
            },
            editForm() {
                this.editMode = true
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                
                Promise.all([
                    this.$http.post("master/get_areas"),
                    this.$http.post("master/clienttypes"),
                    this.$http.post("master/clients"),
                    this.$http.post("master/transporters"),
                    this.$http.post("master/vehicletypes"),
                    this.$http.post("master/contracttypes"),
                    this.$http.post("master/currency"),
                    this.$http.post("master/periodrates"),
                    this.$http.post("master/servicetypes")
                    ])
                .then(this.$http.spread((areas, clienttypes, clients, transporters, vehicletypes, contracttypes, currency, periodrates, servicetypes) => {
                    this.clientOption = clients.data.data;
                    this.areaOptions = areas.data.data;
                    this.transporterOption = transporters.data.data;
                    this.clientTypeOptions = clienttypes.data.data;
                    this.vehicleTypeOption = vehicletypes.data.data;
                    this.contractTypeOption = contracttypes.data.data;
                    this.currencyOption = currency.data;
                    this.periodRateOption = periodrates.data;
                    this.serviceTypeOption = servicetypes.data.data;
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                }))
                .catch(() => {
                    if(this.maxRetry == 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        });
                        return;
                    }
                    // this.fetchAllData()
                })

            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>